import React from "react";
import { DEFAULT_SOUND_FILE } from "../utils/soundOptions";

const DotContext = React.createContext({
  // Theme-derived; not user-configurable. Read at session screens / DotMovement.
  dotColor: "#F2EDE4",
  bgColor: "#1A1614",
  dotGlow: "rgba(242, 237, 228, 0.18)",
  dotSize: 55,
  setDotSize: () => {},
  dotSpeed: 1300, // ~0.77 Hz default
  setDotSpeed: () => {},
  dotBrightness: 1.0, // 0.3 – 1.0; applied as opacity to the dot + glow
  setDotBrightness: () => {},
  sidebarVisible: false,
  setSidebarVisible: () => {},
  shouldRun: false,
  setShouldRun: () => {},
  isPaused: false,
  setIsPaused: () => {},
  exitSession: false,
  setExitSession: () => {},
  soundFile: DEFAULT_SOUND_FILE,
  setSoundFile: () => {},
  mute: false,
  setMute: () => {},
  volume: 0.5,
  setVolume: () => {},
  sessionCuesEnabled: true,
  setSessionCuesEnabled: () => {},
});

export default DotContext;
